<template>
    <Modal class-name="scrollable vertical-center-modal" title="Editar rubro" v-model="show" :footer-hide="true" :scrollable="true">
        <Form style="width: 100%" ref="planForm" :model="heading" :rules="ruleInline">
            <Row :gutter="16">
                <i-col span="24">
                    <FormItem label="Nombre" prop="name">
                        <Input v-model="heading.name" placeholder="Nombre"/>
                    </FormItem>
                </i-col>
                <i-col span="24">
                    <Button style="margin-top: 25px" size="large" long type="primary" :loading="loading" @click="save">Actualizar</Button>
                </i-col>
            </Row>
        </Form>
    </Modal>
</template>

<script>
    export default {
        data(){
            return {
                show: false,
                heading: {
                    name: ""
                },
                loading: false,
                ruleInline: {
                    name: [
                        { required: true, message: 'Nombre es requerido', trigger: 'change' }
                    ],
                },
            }
        },
        methods: {
            save(){
                this.$refs.planForm.validate(valid => {

                    if(valid){
                        this.loading = true
                        window.axios.post(this.$root.API_URL + `/budget/headings/update/${this.heading.id}`, { ...this.heading })
                        .then(response => {
                            if(response.data.success){
                                window.EventBus.$emit('budget-headings--update-heading', response.data.heading)
                                this.show = false
                                this.loading = false
                                this.clear()
                            }
                        })
                        .catch(() => {
                            this.loading = false
                            this.$Message.error('Hubo un problema, no pudimos completar esta acción');
                        })
                    }
                })
            },
            clear(){
                this.heading = {
                    name: ""
                }
            }
        },
        mounted(){
            window.EventBus.$on('budget-headings--update-popup', (heading) => {
                this.heading = {
                    ...heading,
                }
                this.show = true
            })
        }
    }
</script>